export default {
    cn: {
        checkManager: {
            login: 'MT5经理账号',
            password: 'MT5经理密码',
            confirm: '验证',
            success: '保存成功',
        }
    },
    hk: {
        checkManager: {
            login: 'MT5經理賬號',
            password: 'MT5經理密碼',
            confirm: '驗證',
            success: '保存成功',
        }
    },
    en: {
        checkManager: {
            login: 'MT5 Login',
            password: 'MT5 Password',
            confirm: 'Confirm',
            success: 'successfully',
        }
    },
}


// WEBPACK FOOTER //
// ./src/language/checkManager.js